import { gql } from '@apollo/client';

export const ADMIN_CHAT_RECIPIENTS = gql`
  query adminChatRecipients($userIds: [ID!]!) {
    adminChatRecipients(userIds: $userIds) {
      users {
        id
        displayName
        picture
        userLevel
      }
      invalidUserIds
    }
  }
`;

export const SEND_ADMIN_CHAT_MESSAGE = gql`
  mutation sendAdminChatMessage($input: SendAdminChatMessageInput!) {
    sendAdminChatMessage(input: $input) {
      sentCount
      invalidUserIds
      failedUserIds
    }
  }
`;

export const ADMIN_CHAT_SENT_MESSAGES = gql`
  query adminChatSentMessages($userIds: [ID!]!) {
    adminChatSentMessages(userIds: $userIds) {
      messages {
        messageId
        userId
        content
        sent
        style
      }
      invalidUserIds
    }
  }
`;

export const DELETE_ADMIN_CHAT_MESSAGES = gql`
  mutation deleteAdminChatMessages($input: DeleteAdminChatMessagesInput!) {
    deleteAdminChatMessages(input: $input) {
      deletedCount
      failed {
        userId
        messageId
        reason
      }
    }
  }
`;
